function Loading() {
  return (
    <div
      style={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        height: "100vh",
        // backgroundColor: "#f8f9fa",
      }}
    >
      <div className="spinner-border text-primary" role="status">
        <span className="visually-hidden p-4">Loading...</span>
      </div>
    </div>
  );
}

export default Loading;
